export default interface ImpersonationApiKey {
    id: number;
    name: string;
    notes: string;
    userIdentifierType: UserIdentifierType;
    tokenLifetimeInSeconds: number;
    createdDate: Date;
}

export enum UserIdentifierType {
    Email = 1,
    AccountId = 2
}

export function getUserIdentifierTypeName(value: UserIdentifierType) {
    switch (value) {
        case UserIdentifierType.Email:
            return "Email";
        case UserIdentifierType.AccountId:
            return "Account ID";
        default:
            return "Unknown"
    }
}